// Libs
import { ReactNode, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import "./ModalsPortal.scss";

type ModalPropsType = {
    display: boolean,
    element?: ReactNode,
    classCustom?: any
    onClose?: any // funzione passata al componente come props per la chiusura della modale
}
/**
 * ModalPortal component
 * @param {any} children
 * @returns
 */
const ModalPortal = ({ display, element, classCustom, onClose }: ModalPropsType) => {
    const elRef = useRef<any>(null);

    if (!elRef.current) {
        elRef.current = document.createElement("div");
        elRef.current.setAttribute("class", "ModalPortal");
    }

    useEffect(() => {
        const modalRootEl = document.getElementById("modal-root");
        // TYPE DEFF: if there is no div with id "modal-root", in the document, then return. Otherwise proceed.
        if (modalRootEl === null) {
            // SQ cries that we must return a value, but in defensive programming we don't want to return anything, as this effect should not pass.
            // I suggest we use `return undefined`, which is equal to `return`
            return undefined;
        }
        modalRootEl.appendChild(elRef.current);
        return () => {
            modalRootEl.removeChild(elRef.current);
        };
    }, []);
    
    return createPortal(
        <div className={`ModalsPortal__wrapper ${display ? "open" : "closed"} ${classCustom}`}>
            {/* Al click sulla modale viene chiamata la funzione di chiusura */} 
            <div className="ModalsPortal__backdrop" onClick={onClose}></div>
            <div className="ModalPortal__content container">
                <div className="row" onClick={onClose}>
                    {element}
                </div>
            </div>            
        </div>,
    elRef.current);
};

// Default export
export default ModalPortal;
